import { createSlice } from "@reduxjs/toolkit";
import { RPT_FROM_DATE, RPT_TO_DATE } from "../../Utils/FilterDateKeys";

import dateFormat from "dateformat";

const initialState = {
  agName: "",
  rmName: "",
  form: {
    [RPT_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    [RPT_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
  },
};

const reportSlice = createSlice({
    name: "reports",
    initialState,
    reducers: {
      setAgName: (state, action) => {
        state.agName = action.payload;
      },
      setRmName: (state, action) => {
        state.rmName = action.payload;
      },
      setReportForm(state, action) {
        state.form = {
          ...state.form,
          [action.payload.name]: action.payload.value,
        };
      },
    },
  });

export const { setAgName, setRmName, setReportForm } = reportSlice.actions;
export default reportSlice.reducer;
